module.exports = __webpack_public_path__ + "img/icon-more.715b3808.svg";